import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import {
  Box,
  Chip,
  Table,
  Paper,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from "@mui/material";

import Title from "../../../common/Title";
import ApiLogHistory from "../../../common/ApiLogHistory";

import useAxios from "../../../../hooks/useAxios";
import { __getChangePlanLog } from "../../../../api/sim";
import { getChipColor } from "../../../../constants/value";

const ChangePlanHistory = (props) => {
  const [changeHistory, setChangeHistory] = useState([]);
  const { change_plan_id } = useParams();

  const [response, call, loading] = useAxios({
    ...__getChangePlanLog(change_plan_id),
  });

  useEffect(() => {
    if (response && response.status) {
      setChangeHistory(response.data);
    }
  }, [response]);

  useEffect(() => {
    call();
  }, []);

  return loading ? (
    <Title content="Please wait..." variant="subtitle2" gutterBottom />
  ) : (
    <>
      <Box mb={2} pt={2}>
        <Typography variant="h5" align="left">
          Change Plan Log
        </Typography>
      </Box>

      {response && changeHistory.data ? (
        <>
          <Box
            sx={{ width: "100%", mb: 5 }}
            display="flex"
            alignItems="center"
            flexDirection="column"
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">ICCID</TableCell>
                    <TableCell align="left">Batch ID</TableCell>
                    <TableCell align="left">Status</TableCell>
                    <TableCell align="left">Plan</TableCell>
                    <TableCell align="left">Plan Id</TableCell>
                    <TableCell align="left">Old Plan</TableCell>
                    <TableCell align="left">Old Plan Id</TableCell>
                    <TableCell align="left">Last Updated</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="left">
                      {changeHistory.data.iccid}
                    </TableCell>
                    <TableCell align="left">
                      <Link
                        underline="none"
                        to={`/ultra/change_plan/batch/${changeHistory.data.batch_id}`}
                      >
                        {changeHistory.data.batch_id}
                      </Link>
                    </TableCell>
                    <TableCell align="left">
                      <Chip
                        label={changeHistory.data.status}
                        size="small"
                        color={getChipColor(changeHistory.data.status)}
                      />
                    </TableCell>
                    <TableCell align="left">
                      {changeHistory.data.plan}
                    </TableCell>
                    <TableCell align="left">
                      {changeHistory.data.plan_id}
                    </TableCell>
                    <TableCell align="left">
                      {changeHistory.data.old_plan}
                    </TableCell>
                    <TableCell align="left">
                      {changeHistory.data.old_plan_id}
                    </TableCell>
                    <TableCell align="left">
                      {changeHistory.data.last_updated &&
                        `${format(
                          new Date(changeHistory.data.last_updated),
                          "MMMM d, y hh:mm a"
                        )}`}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <ApiLogHistory data={changeHistory.history.data} />
        </>
      ) : (
        <Box mb={2} pt={2}>
          <Typography variant="h5" align="left">
            No Data
          </Typography>
        </Box>
      )}
    </>
  );
};

export default ChangePlanHistory;
